import factory from './icon';
import Svg12x12 from './Glyphs/Close_12x12.svg';
import Svg16x16 from './Glyphs/Close_16x16.svg';
import Svg24x24 from './Glyphs/Close_24x24.svg';

export const Close12x12 = factory(Svg12x12, 12, 12);
export const Close16x16 = factory(Svg16x16, 16, 16);
export const Close24x24 = factory(Svg24x24, 24, 24);
